import express from "../../assets/blogs/express.png";
import greenland from "../../assets/blogs/greenland.jpg";
import furniture from "../../assets/blogs/furniture.jpg";
import motors from "../../assets/blogs/motors.jpg";
import digitalSolutions from "../../assets/blogs/digital-solutions.jpeg";

export const blogPosts = [
  {
    id: 1,
    slug: "iconic-express-premium-bus-service",
    title: "Iconic Express: Redefining Premium Bus Service in Bangladesh",
    excerpt:
      "How Iconic Express is transforming intercity bus travel with comfort, safety, and technology-driven booking systems.",
    category: "transport",
    categoryLabel: "Transport",
    author: "Iconic Unity Group",
    date: "Feb 6, 2026",
    readTime: "7 min read",
    image: express,
    featured: true,
    intro:
      "Iconic Express is building a travel experience where punctuality, onboard comfort, and digital convenience work together for modern passengers.",
    highlights: ["Premium seating", "Smart booking flow", "Reliable nationwide routes"],
    sections: [
      {
        heading: "A better standard for road travel",
        body:
          "The brand is focused on replacing ordinary intercity bus expectations with a cleaner, safer, and more organized passenger journey. From reservation to arrival, every touchpoint is designed to reduce friction and increase confidence.",
      },
      {
        heading: "Technology that supports every trip",
        body:
          "Digital booking, route visibility, customer communication, and smoother service operations help passengers stay informed while helping the team manage demand more effectively.",
      },
      {
        heading: "Service culture matters",
        body:
          "Beyond vehicles and logistics, Iconic Express emphasizes trained staff, punctual departures, and a polished service experience that encourages repeat travel.",
      },
    ],
    relatedNote:
      "Travelers increasingly choose transport brands that combine comfort with dependable service management.",
  },
  {
    id: 2,
    slug: "iconic-greenland-sustainable-communities",
    title: "Iconic Greenland: Building Sustainable Communities",
    excerpt:
      "Discover how Iconic Greenland is shaping the future of real estate with eco-friendly planning and modern architecture.",
    category: "real-estate",
    categoryLabel: "Real Estate",
    author: "Iconic Unity Group",
    date: "Feb 5, 2026",
    readTime: "6 min read",
    image: greenland,
    featured: false,
    intro:
      "Iconic Greenland approaches real estate as long-term community building, balancing livability, design, and future-ready planning.",
    highlights: ["Planned communities", "Green spaces", "Modern urban design"],
    sections: [
      {
        heading: "Planning beyond construction",
        body:
          "The focus is not only on buildings but on how people live, move, and connect within a neighborhood. Infrastructure, open space, and functional layouts are central to the development approach.",
      },
      {
        heading: "Sustainability with practical value",
        body:
          "Energy-conscious choices, thoughtful land use, and smarter residential planning can improve both environmental impact and long-term property appeal.",
      },
      {
        heading: "Creating confidence for buyers",
        body:
          "Clear positioning, modern design language, and a quality-first mindset help establish trust among homeowners and investors alike.",
      },
    ],
    relatedNote:
      "Well-planned communities deliver stronger value when lifestyle and infrastructure are developed together.",
  },
  {
    id: 3,
    slug: "iconic-furniture-comfort-with-elegance",
    title: "Iconic Furniture: Crafting Comfort with Elegance",
    excerpt:
      "Premium furniture solutions designed to blend luxury, durability, and modern aesthetics for every home and office.",
    category: "lifestyle",
    categoryLabel: "Lifestyle",
    author: "Iconic Unity Group",
    date: "Feb 4, 2026",
    readTime: "5 min read",
    image: furniture,
    featured: false,
    intro:
      "Iconic Furniture combines style and functionality to create pieces that feel refined, practical, and long-lasting.",
    highlights: ["Premium finishes", "Modern design", "Home and office solutions"],
    sections: [
      {
        heading: "Design for everyday use",
        body:
          "Furniture should look beautiful, but it also needs to support daily living. The product direction balances visual appeal with comfort, storage, and durability.",
      },
      {
        heading: "A polished material story",
        body:
          "Strong materials, better finishing, and attention to detail help create a more premium perception while extending product life.",
      },
      {
        heading: "Versatility across spaces",
        body:
          "From corporate interiors to family homes, adaptable design collections make it easier to serve a broader customer base without losing identity.",
      },
    ],
    relatedNote:
      "Furniture brands grow faster when they unite craftsmanship, comfort, and a recognizable visual identity.",
  },
  {
    id: 4,
    slug: "iconic-soft-business-technology",
    title: "Iconic Soft Ltd.: Empowering Businesses Through Technology",
    excerpt:
      "From web applications to enterprise software, Iconic Soft Ltd. delivers scalable digital solutions for modern businesses.",
    category: "technology",
    categoryLabel: "Technology",
    author: "Iconic Unity Group",
    date: "Feb 3, 2026",
    readTime: "8 min read",
    image: "https://i.pinimg.com/736x/c8/be/cd/c8becd9b204347795988356638a6aff8.jpg",
    featured: false,
    intro:
      "Iconic Soft Ltd. supports business growth by building dependable digital products that improve efficiency, customer experience, and operational visibility.",
    highlights: ["Custom software", "Scalable systems", "Digital transformation"],
    sections: [
      {
        heading: "Solutions built around business needs",
        body:
          "Rather than forcing companies into rigid tools, the team focuses on software that reflects real workflows, approval chains, reporting needs, and customer journeys.",
      },
      {
        heading: "Scalability from the start",
        body:
          "Modern businesses need platforms that can evolve. Product decisions are shaped around maintainability, integration potential, and future expansion.",
      },
      {
        heading: "Technology as a growth enabler",
        body:
          "The strongest digital solutions do more than automate tasks. They create better decisions, clearer communication, and stronger service delivery across teams.",
      },
    ],
    relatedNote:
      "The most useful software is the kind that teams adopt easily and can keep growing with.",
  },
  {
    id: 5,
    slug: "iconic-digital-solution-transforming-brands",
    title: "Iconic Digital Solution: Transforming Brands Online",
    excerpt:
      "Helping businesses grow through digital marketing, branding, and data-driven online strategies.",
    category: "business",
    categoryLabel: "Business",
    author: "Iconic Unity Group",
    date: "Feb 2, 2026",
    readTime: "6 min read",
    image: digitalSolutions,
    featured: false,
    intro:
      "Iconic Digital Solution helps brands sharpen their presence online through strategy, storytelling, and measurable campaign execution.",
    highlights: ["Brand strategy", "Performance marketing", "Content and visibility"],
    sections: [
      {
        heading: "Building stronger digital presence",
        body:
          "Growth online depends on more than activity. It requires clear messaging, consistent visuals, and a strategy matched to audience behavior.",
      },
      {
        heading: "Data supports better decisions",
        body:
          "Campaign performance, audience signals, and conversion insights help refine messaging and spend so brands can grow more efficiently.",
      },
      {
        heading: "From awareness to trust",
        body:
          "Strong digital branding helps businesses stay memorable while creating the consistency needed to earn long-term customer confidence.",
      },
    ],
    relatedNote:
      "Online growth becomes more sustainable when branding and performance strategy move together.",
  },
  {
    id: 6,
    slug: "iconic-hajj-group-sacred-journeys",
    title: "Iconic Hajj Group: A Trusted Companion for Sacred Journeys",
    excerpt:
      "Providing reliable Hajj and Umrah services with complete guidance, comfort, and spiritual care.",
    category: "travel",
    categoryLabel: "Travel",
    author: "Iconic Unity Group",
    date: "Feb 1, 2026",
    readTime: "7 min read",
    image: "https://i.pinimg.com/736x/3e/6c/c1/3e6cc1b95e3aad2a94b65a1a7d0bab05.jpg",
    featured: false,
    intro:
      "Iconic Hajj Group is dedicated to making every Hajj and Umrah journey organized, peaceful, and spiritually reassuring for pilgrims and their families.",
    highlights: ["End-to-end pilgrimage support", "Experienced guidance", "Comfort-focused arrangements"],
    sections: [
      {
        heading: "Guidance with care and clarity",
        body:
          "Pilgrims need more than a travel package. They need trusted direction before departure, structured support during the journey, and calm problem-solving whenever questions arise.",
      },
      {
        heading: "Comfort that protects focus",
        body:
          "Well-managed accommodations, transportation coordination, and timely communication help travelers stay focused on their ibadah instead of travel stress.",
      },
      {
        heading: "A service rooted in responsibility",
        body:
          "Families choose sacred travel partners based on reliability and sincerity. Iconic Hajj Group aims to serve with professionalism, empathy, and respect for the significance of the journey.",
      },
    ],
    relatedNote:
      "Pilgrimage services earn trust when operational discipline and spiritual sensitivity are both visible.",
  },
  {
    id: 7,
    slug: "iconic-motors-automotive-excellence",
    title: "Iconic Motors: Driving the Future of Automotive Excellence",
    excerpt:
      "From vehicle sales to after-sales service, Iconic Motors ensures quality, performance, and customer satisfaction.",
    category: "automotive",
    categoryLabel: "Automotive",
    author: "Iconic Unity Group",
    date: "Jan 30, 2026",
    readTime: "6 min read",
    image: motors,
    featured: false,
    intro:
      "Iconic Motors is shaping an automotive experience centered on trust, vehicle quality, and dependable after-sales support.",
    highlights: ["Vehicle quality", "After-sales service", "Customer-first experience"],
    sections: [
      {
        heading: "Confidence starts before purchase",
        body:
          "Customers want clarity on quality, value, and ownership experience. A strong automotive brand makes the buying journey simpler and more transparent.",
      },
      {
        heading: "After-sales defines loyalty",
        body:
          "Service support, maintenance trust, and responsiveness often matter more than the initial sale in shaping long-term brand reputation.",
      },
      {
        heading: "Performance with peace of mind",
        body:
          "The goal is not only to deliver vehicles, but to back them with care systems that help customers feel secure over time.",
      },
    ],
    relatedNote:
      "Automotive brands stand out when service quality remains strong well after the sale is complete.",
  },
];

export const categoryLabels = {
  all: "All Posts",
  technology: "Technology",
  business: "Business",
  "real-estate": "Real Estate",
  transport: "Transport",
  travel: "Travel",
  automotive: "Automotive",
  lifestyle: "Lifestyle",
};
